/**
 * Returnerer Authorized fra HN.rest objektet
 */
export const isAuthorized = () => {
    if (typeof document === 'undefined') {
        return false;
    }
    return !!window.HN?.Rest?.Authorized;
};
